/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum SiteMetadataType {
  Blog = 'blog',
  Pages = 'pages',
  Services = 'services',
}

export function instanceOfSiteMetadataType(value: any): boolean {
  for (const key in SiteMetadataType) {
    if (Object.prototype.hasOwnProperty.call(SiteMetadataType, key)) {
      if (SiteMetadataType[key as keyof typeof SiteMetadataType] === value) {
        return true
      }
    }
  }
  return false
}

export function SiteMetadataTypeFromJSON(json: any): SiteMetadataType {
  return SiteMetadataTypeFromJSONTyped(json, false)
}

export function SiteMetadataTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SiteMetadataType {
  return json as SiteMetadataType
}

export function SiteMetadataTypeToJSON(value?: SiteMetadataType | null): any {
  return value as any
}
